/* TG Racing — theme.js */
(function () {
  'use strict';

  /* =============================================
     SCROLL REVEAL
     ============================================= */
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

  function initReveal() {
    document.querySelectorAll('.reveal-item').forEach(el => revealObserver.observe(el));
  }

  /* =============================================
     STICKY HEADER SHADOW
     ============================================= */
  function initStickyHeader() {
    const header = document.querySelector('.site-header');
    if (!header) return;
    const observer = new IntersectionObserver(
      ([e]) => header.classList.toggle('scrolled', !e.isIntersecting),
      { threshold: 1, rootMargin: '-64px 0px 0px 0px' }
    );
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;position:absolute;top:0;width:100%;pointer-events:none';
    document.body.prepend(sentinel);
    observer.observe(sentinel);
  }

  /* =============================================
     SEARCH DRAWER
     ============================================= */
  function initSearch() {
    const toggle  = document.querySelector('.search-toggle');
    const drawer  = document.getElementById('SearchDrawer');
    const close   = drawer && drawer.querySelector('.search-close');
    const overlay = document.getElementById('Overlay');
    const input   = drawer && drawer.querySelector('.search-input');

    if (!toggle || !drawer) return;

    function openSearch() {
      drawer.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      overlay.classList.add('is-active');
      setTimeout(() => input && input.focus(), 50);
    }

    function closeSearch() {
      drawer.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      overlay.classList.remove('is-active');
      closeMobileMenu();
    }

    toggle.addEventListener('click', openSearch);
    close && close.addEventListener('click', closeSearch);
    overlay.addEventListener('click', () => { closeSearch(); closeMobileMenu(); });

    // Category pills — append to search query
    const pills = drawer.querySelectorAll('.cat-pill');
    const searchForm = drawer.querySelector('.search-form');

    pills.forEach(pill => {
      pill.addEventListener('click', () => {
        pills.forEach(p => p.classList.remove('active'));
        pill.classList.add('active');

        let hiddenCat = searchForm.querySelector('input[name="q\\[collection\\]"]');
        if (!hiddenCat) {
          hiddenCat = document.createElement('input');
          hiddenCat.type = 'hidden';
          hiddenCat.name = 'q[collection]';
          searchForm.appendChild(hiddenCat);
        }

        const cat = pill.dataset.cat;
        hiddenCat.value = cat === 'all' ? '' : cat;
      });
    });

    // ESC key
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') { closeSearch(); closeMobileMenu(); }
    });
  }

  /* =============================================
     MOBILE MENU
     ============================================= */
  let mobileMenuOpen = false;

  function closeMobileMenu() {
    const menu   = document.getElementById('MobileMenu');
    const toggle = document.querySelector('.menu-toggle');
    const overlay = document.getElementById('Overlay');
    if (!menu) return;
    menu.setAttribute('hidden', '');
    toggle && toggle.setAttribute('aria-expanded', 'false');
    overlay && overlay.classList.remove('is-active');
    mobileMenuOpen = false;
    document.body.style.overflow = '';
  }

  function initMobileMenu() {
    const toggle = document.querySelector('.menu-toggle');
    const menu   = document.getElementById('MobileMenu');
    const close  = menu && menu.querySelector('.mobile-close');
    const overlay = document.getElementById('Overlay');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      if (mobileMenuOpen) {
        closeMobileMenu();
      } else {
        menu.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        overlay.classList.add('is-active');
        mobileMenuOpen = true;
        document.body.style.overflow = 'hidden';
      }
    });

    close && close.addEventListener('click', closeMobileMenu);
  }

  /* =============================================
     PRODUCT PAGE — THUMBNAIL GALLERY
     ============================================= */
  function initProductGallery() {
    const thumbs = document.querySelectorAll('.product-thumb');
    const featImg = document.getElementById('ProductFeaturedImage');
    if (!thumbs.length || !featImg) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        thumbs.forEach(t => t.classList.remove('active'));
        thumb.classList.add('active');
        featImg.style.opacity = '0';
        setTimeout(() => {
          featImg.src = thumb.dataset.imageUrl;
          featImg.alt = thumb.dataset.imageAlt;
          featImg.style.opacity = '1';
        }, 150);
      });
    });
  }

  /* =============================================
     PRODUCT PAGE — VARIANT SELECTOR
     ============================================= */
  function initVariantSelector() {
    const select = document.getElementById('ProductVariantSelect');
    const radios = document.querySelectorAll('.option-radio');
    const priceEl = document.querySelector('.product-price');
    const comparePriceEl = document.querySelector('.product-price--compare');
    const addBtn = document.querySelector('.btn-atc');
    if (!select) return;

    function updateFromSelect() {
      const selected = select.options[select.selectedIndex];
      if (!selected) return;
      const price = parseInt(selected.dataset.price, 10);
      const cmp   = parseInt(selected.dataset.comparePrice, 10);
      const avail = !selected.disabled;

      if (priceEl) {
        priceEl.textContent = formatMoney(price);
        priceEl.classList.toggle('product-price--sale', cmp > price);
      }
      if (comparePriceEl) {
        comparePriceEl.textContent = cmp > price ? formatMoney(cmp) : '';
        comparePriceEl.style.display = cmp > price ? '' : 'none';
      }
      if (addBtn) {
        addBtn.disabled = !avail;
        addBtn.textContent = avail ? 'Add to Cart' : 'Sold Out';
      }
    }

    radios.forEach(radio => {
      radio.addEventListener('change', () => {
        // Build title from all selected options
        const form = radio.closest('form');
        if (!form) return;
        const selections = [...form.querySelectorAll('.option-radio:checked')]
          .map(r => r.value).join(' / ');

        // Match to select option
        for (const opt of select.options) {
          if (opt.textContent.trim().startsWith(selections)) {
            select.value = opt.value;
            break;
          }
        }
        updateFromSelect();
      });
    });

    select.addEventListener('change', updateFromSelect);
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* =============================================
     QTY SELECTORS (product page & cart)
     ============================================= */
  function initQtySelectors() {
    document.querySelectorAll('.qty-selector').forEach(sel => {
      const input    = sel.querySelector('.qty-input');
      const decrease = sel.querySelector('[data-action="decrease"]');
      const increase = sel.querySelector('[data-action="increase"]');
      if (!input) return;

      decrease && decrease.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        if (val > 1) input.value = val - 1;
        input.dispatchEvent(new Event('change'));
      });

      increase && increase.addEventListener('click', () => {
        const val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    });
  }

  /* =============================================
     ADD TO CART — AJAX
     ============================================= */
  function initAjaxCart() {
    document.querySelectorAll('.product-card-form').forEach(form => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('.btn-add-to-cart');
        const id  = form.querySelector('input[name="id"]');
        if (!id) return;

        btn.style.background = 'var(--clr-accent)';
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>';

        try {
          await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id.value, quantity: 1 })
          });
          updateCartCount();
        } catch (err) {
          console.error('Add to cart failed:', err);
        }

        setTimeout(() => {
          btn.style.background = '';
          btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
        }, 1800);
      });
    });
  }

  async function updateCartCount() {
    try {
      const res  = await fetch('/cart.js');
      const cart = await res.json();
      const countEl = document.querySelector('.cart-count');
      if (cart.item_count > 0) {
        if (countEl) {
          countEl.textContent = cart.item_count;
        } else {
          const icon = document.querySelector('.cart-icon');
          if (icon) {
            const span = document.createElement('span');
            span.className = 'cart-count';
            span.textContent = cart.item_count;
            icon.appendChild(span);
          }
        }
      }
    } catch (e) { /* silent */ }
  }

  /* =============================================
     CART — REMOVE ITEMS
     ============================================= */
  function initCartRemovals() {
    document.querySelectorAll('.cart-remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        const key = btn.dataset.key;
        if (!key) return;
        const item = btn.closest('.cart-item');
        item && (item.style.opacity = '0.4');
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
          location.reload();
        } catch (e) { item && (item.style.opacity = '1'); }
      });
    });
  }

  /* =============================================
     COLLECTION — SORT
     ============================================= */
  function initSort() {
    const sel = document.getElementById('SortBy');
    if (!sel) return;
    sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    });
  }

  /* =============================================
     CATEGORY SWIPE DOTS
     ============================================= */
  function initSwipeDots() {
    const grid = document.getElementById('CategoryGrid');
    const dots = document.querySelectorAll('#SwipeDots .swipe-dot');
    if (!grid || !dots.length) return;

    grid.addEventListener('scroll', () => {
      const cardWidth = grid.querySelector('.cat-card')?.offsetWidth || 1;
      const index = Math.round(grid.scrollLeft / (cardWidth + 16)); // 16 = gap
      dots.forEach((d, i) => d.classList.toggle('active', i === index));
    }, { passive: true });
  }

  /* =============================================
     INIT
     ============================================= */
  document.addEventListener('DOMContentLoaded', () => {
    initReveal();
    initStickyHeader();
    initSearch();
    initMobileMenu();
    initProductGallery();
    initVariantSelector();
    initQtySelectors();
    initAjaxCart();
    initCartRemovals();
    initSort();
    initSwipeDots();
  });

})();
